import { useEffect } from 'react'

export interface useRoadViewViewModelProps {
  lat?: number
  lng?: number
  setIsRoadviewFail: React.Dispatch<React.SetStateAction<boolean>>
}

export interface RoadViewViewModel {
  texts: object
  states: object
  setters: object
  handlers: object
}

const useRoadViewViewModel = ({ lat, lng, setIsRoadviewFail }: useRoadViewViewModelProps): RoadViewViewModel => {
  useEffect(() => {
    const roadviewScript = document.createElement('script')
    roadviewScript.async = true
    roadviewScript.src = `//dapi.kakao.com/v2/maps/sdk.js?appkey=${process.env.NEXT_PUBLIC_KAKAO_API_JS_KEY}&autoload=false&libraries=services,clusterer`

    document.head.appendChild(roadviewScript)

    const onLoadKakaoRoadView = () => {
      window.kakao.maps.load(() => {
        const roadviewContainer = document.getElementById('roadview') as HTMLElement

        const position = new kakao.maps.LatLng(lat || 37.5691633, lng || 126.9773151)
        const client = new kakao.maps.RoadviewClient()
        const view = new kakao.maps.Roadview(roadviewContainer)
        client.getNearestPanoId(position, 50, (panoId) => {
          if (panoId == null) {
            setIsRoadviewFail(true)
          } else {
            view.setPanoId(panoId, position)
          }
        })
      })
    }

    roadviewScript.addEventListener('load', onLoadKakaoRoadView)

    return () => {
      document.head.removeChild(roadviewScript)
      roadviewScript.removeEventListener('load', onLoadKakaoRoadView)
    }
  }, [])

  return {
    texts: {},
    states: {},
    setters: {},
    handlers: {}
  }
}

export default useRoadViewViewModel
